import React from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../../../assets/icons/red-warning.svg";
import Loader from "../../../loader/Loader";
import "./DeleteQuickFileAlbumModal.less";

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
};

const DeleteQuickFileAlbumModal: React.FC<Props> = ({ isOpen, onConfirm, onCancel, isDeleting = false }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!isDeleting) {
      onCancel?.();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="delete-quick-file-album-overlay" onClick={handleOverlayClick}>
      <div className="delete-quick-file-album-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="delete-quick-file-album-container">
          <img src={RedWarningIcon} className="delete-quick-file-album-icon" alt="Warning" />
          <div className="delete-quick-file-album-title">{t("delete-quickfile-album-confirm-title")}</div>
          <div className="delete-quick-file-album-desc">{t("delete-quickfile-album-confirm-desc")}</div>
          <button
            type="button"
            className="delete-quick-file-album-confirm-button"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? <Loader size="small" inline /> : t("confirm")}
          </button>
          <button
            type="button"
            className="delete-quick-file-album-cancel-button"
            onClick={onCancel}
            disabled={isDeleting}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteQuickFileAlbumModal;
